<template>
  <g>
    <path :d="'M' + A.x + ' ' + A.y + ' L' + B.x + ' ' + B.y + ' L' + C.x + ' ' + C.y + ' L' + D.x + ' ' + D.y + ' L' + E.x + ' ' + E.y + ' L' + F.x + ' ' + F.y + 'Z'" stroke="#b1b1b1" stroke-width="1" :style="materialColor.hex != '' && formComplete ? {'fill': materialColor.hex} : {'fill': '#fff'}"/>
    <g v-if="formComplete">
      <g v-for="(side, index) in sides" :key="index">
        <line :x1="side.border.line.xStart" :y1="side.border.line.yStart" :x2="side.border.line.xEnd" :y2="side.border.line.yEnd" stroke="#ddd" stroke-width="1"/>
        <polygon :points="side.border.corner.start" :transform="side.border.corner.rotateStart" stroke="#ddd" stroke-width="1" fill="#ddd"/>
        <polygon :points="side.border.corner.end" :transform="side.border.corner.rotateEnd" stroke="#ddd" stroke-width="1" fill="#ddd"/>
        <rect :x="side.labelBackground.x" :y="side.labelBackground.y" :width="side.labelBackground.width" :height="side.labelBackground.height" style="fill:#fff" />
      </g>
    </g>
    <text v-for="side in sides" :key="side.id" dominant-baseline="middle" text-anchor="middle" fill="#002b36">
      <tspan v-if="formComplete" :x="side.labelSpace.x" :y="side.labelSpace.y" class="font-weight-bold" font-size="1em">{{side.name}}</tspan>
      <tspan v-if="formComplete" :x="side.labelSpace.x" dy="1.5em" font-size="0.7em">{{side.size}} cm</tspan>
      <tspan v-if="materialComplete" :x="side.labelSpace.x" dy="1em" font-size="0.7em">{{side.rand}}</tspan>
    </text>
    <g v-if="materialComplete">
      <g v-for="side in sides" :key="side.id">
        <g v-if="side.rand === rand.saum.titleSaum.name">
          <path :d="side.saum" stroke-width="1" stroke="#b1b1b1" stroke-dasharray="3,3"/>
          <g v-if="activeOesenArt">
            <circle v-for="(item, index) in side.oesenAnzahl" :key="index" :cx="side.oesenAbstand.x(index, side.oesenAnzahl)" :cy="side.oesenAbstand.y(index, side.oesenAnzahl)" r="3" stroke="#b1b1b1" stroke-width="2" fill="#fff" />
          </g>
        </g>
        <path v-if="side.rand === rand.hohlsaum.title.name" :d="side.hohlsaum" stroke-width="1" stroke="#b1b1b1"/>
      </g>
    </g>
  </g>
</template>

<script>
import DataRandArt from '../../../../../data/main/config/setup/rand/randArt'

import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      rand: DataRandArt.randArt,
      A: {
        x: 425 - 175 * this.sinCalc(30) - 175,
        y: 250 + 175 * this.sinCalc(60)
      },
      B: {
        x: 75,
        y: 250
      },
      C: {
        x: 75 + 175 * this.sinCalc(30),
        y: 250 - 175 * this.sinCalc(60)
      },
      D: {
        x: 75 + 175 * this.sinCalc(30) + 175,
        y: 250 - 175 * this.sinCalc(60)
      },
      E: {
        x: 425,
        y: 250
      },
      F: {
        x: 425 - 175 * this.sinCalc(30),
        y: 250 + 175 * this.sinCalc(60)
      }
    }
  },
  methods: {
    sinCalc (alpha) {
      return Math.sin(alpha * Math.PI / 180)
    }
  },
  computed: {
    ...mapGetters([
      'materialColor',
      'randSides',
      'formComplete',
      'materialComplete',
      'activeOesenArt',
      'calcSides'
    ]),
    sides () {
      return {
        a: {
          name: 'a',
          size: Math.round(this.calcSides[0]),
          rand: this.randSides[0].type.name,
          oesenAnzahl: this.randSides[0].oesenAnzahl,
          oesenAbstand: {
            xStart: this.A.x + 15 * this.sinCalc(30) / this.sinCalc(60),
            xEnd: this.F.x - 15 * this.sinCalc(30) / this.sinCalc(60),
            yConst: this.A.y - 15,
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              return this.yConst
            }
          },
          saum: 'M' + (this.A.x - 30 / this.sinCalc(60) * this.sinCalc(30)) + ' ' + (this.A.y - 30) + ' L' + (this.F.x + 30 / this.sinCalc(60) * this.sinCalc(30)) + ' ' + (this.F.y - 30),
          hohlsaum: 'M' + (this.A.x - 9 / this.sinCalc(60) * this.sinCalc(30)) + ' ' + (this.A.y - 9) + ' L' + (this.F.x + 9 / this.sinCalc(60) * this.sinCalc(30)) + ' ' + (this.F.y - 9),
          labelSpace: {
            x: 250,
            y: 430
          },
          labelBackground: {
            x: 215,
            y: 415,
            width: 70,
            height: 60
          },
          border: {
            line: {
              xStart: this.A.x,
              yStart: this.A.y + 40,
              xEnd: this.F.x,
              yEnd: this.F.y + 40
            },
            corner: {
              start: this.A.x + ',' + (this.A.y + 40) + ' ' + (this.A.x + 10) + ',' + (this.A.y + 35) + ' ' + (this.A.x + 10) + ',' + (this.A.y + 45),
              rotateStart: 'rotate(0, ' + this.A.x + ', ' + (this.A.y + 40) + ')',
              end: this.F.x + ',' + (this.F.y + 40) + ' ' + (this.F.x - 10) + ',' + (this.F.y + 35) + ' ' + (this.F.x - 10) + ',' + (this.F.y + 45),
              rotateEnd: 'rotate(0, ' + this.F.x + ', ' + (this.F.y + 40) + ')'
            }
          },
          id: 1
        },
        b: {
          name: 'b',
          size: Math.round(this.calcSides[1]),
          rand: this.randSides[1].type.name,
          oesenAnzahl: this.randSides[1].oesenAnzahl,
          oesenAbstand: {
            xStart: this.A.x + 15 * this.sinCalc(30) / this.sinCalc(60),
            xEnd: this.B.x + 15 / this.sinCalc(60),
            yStart: this.A.y - 15,
            yEnd: this.B.y,
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return (this.yStart + this.yEnd) / 2
              } if (item === 2) {
                return this.yStart + i * (this.yEnd - this.yStart)
              } else {
                return this.yStart + (i / (item - 1)) * (this.yEnd - this.yStart)
              }
            }
          },
          saum: 'M' + (this.A.x + 30 / this.sinCalc(60)) + ' ' + this.A.y + ' L' + (this.B.x + this.sinCalc(30) * 30 / this.sinCalc(60)) + ' ' + (this.B.y - 30),
          hohlsaum: 'M' + (this.A.x + 9 / this.sinCalc(60)) + ' ' + this.A.y + ' L' + (this.B.x + this.sinCalc(30) * 9 / this.sinCalc(60)) + ' ' + (this.B.y - 9),
          labelSpace: {
            x: 75,
            y: 340
          },
          labelBackground: {
            x: 40,
            y: 320,
            width: 70,
            height: 60
          },
          border: {
            line: {
              xStart: this.A.x - this.sinCalc(60) * 40,
              yStart: this.A.y + this.sinCalc(30) * 40,
              xEnd: this.B.x - this.sinCalc(60) * 40,
              yEnd: this.B.y + this.sinCalc(30) * 40
            },
            corner: {
              start: (this.A.x - this.sinCalc(60) * 40) + ',' + (this.A.y + this.sinCalc(30) * 40) + ' ' + (this.A.x - this.sinCalc(60) * 40 - 5) + ',' + (this.A.y + this.sinCalc(30) * 40 - 10) + ' ' + (this.A.x - this.sinCalc(60) * 40 + 5) + ',' + (this.A.y + this.sinCalc(30) * 40 - 10),
              rotateStart: 'rotate(-30, ' + (this.A.x - this.sinCalc(60) * 40) + ', ' + (this.A.y + this.sinCalc(30) * 40) + ')',
              end: (this.B.x - this.sinCalc(60) * 40) + ',' + (this.B.y + this.sinCalc(30) * 40) + ' ' + (this.B.x - this.sinCalc(60) * 40 - 5) + ',' + (this.B.y + this.sinCalc(30) * 40 + 10) + ' ' + (this.B.x - this.sinCalc(60) * 40 + 5) + ',' + (this.B.y + this.sinCalc(30) * 40 + 10),
              rotateEnd: 'rotate(-30, ' + (this.B.x - this.sinCalc(60) * 40) + ', ' + (this.B.y + this.sinCalc(30) * 40) + ')'
            }
          },
          id: 2
        },
        c: {
          name: 'c',
          size: Math.round(this.calcSides[2]),
          rand: this.randSides[2].type.name,
          oesenAnzahl: this.randSides[2].oesenAnzahl,
          oesenAbstand: {
            xStart: this.B.x + 15 / this.sinCalc(60),
            xEnd: this.C.x + 15 / this.sinCalc(60) * this.sinCalc(30),
            yStart: this.B.y,
            yEnd: this.C.y + 15,
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return (this.yStart + this.yEnd) / 2
              } if (item === 2) {
                return this.yStart + i * (this.yEnd - this.yStart)
              } else {
                return this.yStart + (i / (item - 1)) * (this.yEnd - this.yStart)
              }
            }
          },
          saum: 'M' + (this.B.x + this.sinCalc(30) * 30 / this.sinCalc(60)) + ' ' + (this.B.y + 30) + ' L' + (this.C.x + 30 / this.sinCalc(60)) + ' ' + this.C.y,
          hohlsaum: 'M' + (this.B.x + this.sinCalc(30) * 9 / this.sinCalc(60)) + ' ' + (this.B.y + 9) + ' L' + (this.C.x + 9 / this.sinCalc(60)) + ' ' + this.C.y,
          labelSpace: {
            x: 75,
            y: 138
          },
          labelBackground: {
            x: 40,
            y: 120,
            width: 70,
            height: 60
          },
          border: {
            line: {
              xStart: this.B.x - this.sinCalc(60) * 40,
              yStart: this.B.y - this.sinCalc(30) * 40,
              xEnd: this.C.x - this.sinCalc(60) * 40,
              yEnd: this.C.y - this.sinCalc(30) * 40
            },
            corner: {
              start: (this.B.x - this.sinCalc(60) * 40) + ',' + (this.B.y - this.sinCalc(30) * 40) + ' ' + (this.B.x - this.sinCalc(60) * 40 - 5) + ',' + (this.B.y - this.sinCalc(30) * 40 - 10) + ' ' + (this.B.x - this.sinCalc(60) * 40 + 5) + ',' + (this.B.y - this.sinCalc(30) * 40 - 10),
              rotateStart: 'rotate(30, ' + (this.B.x - this.sinCalc(60) * 40) + ', ' + (this.B.y - this.sinCalc(30) * 40) + ')',
              end: (this.C.x - this.sinCalc(60) * 40) + ',' + (this.C.y - this.sinCalc(30) * 40) + ' ' + (this.C.x - this.sinCalc(60) * 40 - 5) + ',' + (this.C.y - this.sinCalc(30) * 40 + 10) + ' ' + (this.C.x - this.sinCalc(60) * 40 + 5) + ',' + (this.C.y - this.sinCalc(30) * 40 + 10),
              rotateEnd: 'rotate(30, ' + (this.C.x - this.sinCalc(60) * 40) + ', ' + (this.C.y - this.sinCalc(30) * 40) + ')'
            }
          },
          id: 3
        },
        d: {
          name: 'd',
          size: Math.round(this.calcSides[3]),
          rand: this.randSides[3].type.name,
          oesenAnzahl: this.randSides[3].oesenAnzahl,
          oesenAbstand: {
            xStart: this.C.x + 15 * this.sinCalc(30) / this.sinCalc(60),
            xEnd: this.D.x - 15 * this.sinCalc(30) / this.sinCalc(60),
            yConst: this.C.y + 15,
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              return this.yConst
            }
          },
          saum: 'M' + (this.C.x - 30 / this.sinCalc(60) * this.sinCalc(30)) + ' ' + (this.C.y + 30) + ' L' + (this.D.x + 30 / this.sinCalc(60) * this.sinCalc(30)) + ' ' + (this.D.y + 30),
          hohlsaum: 'M' + (this.C.x - 9 / this.sinCalc(60) * this.sinCalc(30)) + ' ' + (this.C.y + 9) + ' L' + (this.D.x + 9 / this.sinCalc(60) * this.sinCalc(30)) + ' ' + (this.D.y + 9),
          labelSpace: {
            x: 250,
            y: 50
          },
          labelBackground: {
            x: 215,
            y: 30,
            width: 70,
            height: 60
          },
          border: {
            line: {
              xStart: this.C.x,
              yStart: this.C.y - 40,
              xEnd: this.D.x,
              yEnd: this.D.y - 40
            },
            corner: {
              start: this.C.x + ',' + (this.C.y - 40) + ' ' + (this.C.x + 10) + ',' + (this.C.y - 35) + ' ' + (this.C.x + 10) + ',' + (this.C.y - 45),
              rotateStart: 'rotate(0, ' + this.C.x + ', ' + (this.C.y - 40) + ')',
              end: this.D.x + ',' + (this.D.y - 40) + ' ' + (this.D.x - 10) + ',' + (this.D.y - 35) + ' ' + (this.D.x - 10) + ',' + (this.D.y - 45),
              rotateEnd: 'rotate(0, ' + this.D.x + ', ' + (this.D.y - 40) + ')'
            }
          },
          id: 4
        },
        e: {
          name: 'e',
          size: Math.round(this.calcSides[4]),
          rand: this.randSides[4].type.name,
          oesenAnzahl: this.randSides[4].oesenAnzahl,
          oesenAbstand: {
            xStart: this.D.x - 15 / this.sinCalc(60) * this.sinCalc(30),
            xEnd: this.E.x - 15 / this.sinCalc(60),
            yStart: this.D.y + 15,
            yEnd: this.E.y,
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return (this.yStart + this.yEnd) / 2
              } if (item === 2) {
                return this.yStart + i * (this.yEnd - this.yStart)
              } else {
                return this.yStart + (i / (item - 1)) * (this.yEnd - this.yStart)
              }
            }
          },
          saum: 'M' + (this.D.x - 30 / this.sinCalc(60)) + ' ' + this.D.y + ' L' + (this.E.x - this.sinCalc(30) * 30 / this.sinCalc(60)) + ' ' + (this.E.y + 30),
          hohlsaum: 'M' + (this.D.x - 9 / this.sinCalc(60)) + ' ' + this.D.y + ' L' + (this.E.x - this.sinCalc(30) * 9 / this.sinCalc(60)) + ' ' + (this.E.y + 9),
          labelSpace: {
            x: 425,
            y: 138
          },
          labelBackground: {
            x: 390,
            y: 120,
            width: 70,
            height: 60
          },
          border: {
            line: {
              xStart: this.E.x + this.sinCalc(60) * 40,
              yStart: this.E.y - this.sinCalc(30) * 40,
              xEnd: this.D.x + this.sinCalc(60) * 40,
              yEnd: this.D.y - this.sinCalc(30) * 40
            },
            corner: {
              start: (this.E.x + this.sinCalc(60) * 40) + ',' + (this.E.y - this.sinCalc(30) * 40) + ' ' + (this.E.x + this.sinCalc(60) * 40 - 5) + ',' + (this.E.y - this.sinCalc(30) * 40 - 10) + ' ' + (this.E.x + this.sinCalc(60) * 40 + 5) + ',' + (this.E.y - this.sinCalc(30) * 40 - 10),
              rotateStart: 'rotate(-30, ' + (this.E.x + this.sinCalc(60) * 40) + ', ' + (this.E.y - this.sinCalc(30) * 40) + ')',
              end: (this.D.x + this.sinCalc(60) * 40) + ',' + (this.D.y - this.sinCalc(30) * 40) + ' ' + (this.D.x + this.sinCalc(60) * 40 - 5) + ',' + (this.D.y - this.sinCalc(30) * 40 + 10) + ' ' + (this.D.x + this.sinCalc(60) * 40 + 5) + ',' + (this.D.y - this.sinCalc(30) * 40 + 10),
              rotateEnd: 'rotate(-30, ' + (this.D.x + this.sinCalc(60) * 40) + ', ' + (this.D.y - this.sinCalc(30) * 40) + ')'
            }
          },
          id: 5
        },
        f: {
          name: 'f',
          size: Math.round(this.calcSides[5]),
          rand: this.randSides[5].type.name,
          oesenAnzahl: this.randSides[5].oesenAnzahl,
          oesenAbstand: {
            xStart: this.F.x - 15 * this.sinCalc(30) / this.sinCalc(60),
            xEnd: this.E.x - 15 / this.sinCalc(60),
            yStart: this.F.y - 15,
            yEnd: this.E.y,
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return (this.yStart + this.yEnd) / 2
              } if (item === 2) {
                return this.yStart + i * (this.yEnd - this.yStart)
              } else {
                return this.yStart + (i / (item - 1)) * (this.yEnd - this.yStart)
              }
            }
          },
          saum: 'M' + (this.F.x - 30 / this.sinCalc(60)) + ' ' + this.F.y + ' L' + (this.E.x - this.sinCalc(30) * 30 / this.sinCalc(60)) + ' ' + (this.E.y - 30),
          hohlsaum: 'M' + (this.F.x - 9 / this.sinCalc(60)) + ' ' + this.F.y + ' L' + (this.E.x - this.sinCalc(30) * 9 / this.sinCalc(60)) + ' ' + (this.E.y - 9),
          labelSpace: {
            x: 425,
            y: 340
          },
          labelBackground: {
            x: 390,
            y: 320,
            width: 70,
            height: 60
          },
          border: {
            line: {
              xStart: this.F.x + this.sinCalc(60) * 40,
              yStart: this.F.y + this.sinCalc(30) * 40,
              xEnd: this.E.x + this.sinCalc(60) * 40,
              yEnd: this.E.y + this.sinCalc(30) * 40
            },
            corner: {
              start: (this.F.x + this.sinCalc(60) * 40) + ',' + (this.F.y + this.sinCalc(30) * 40) + ' ' + (this.F.x + this.sinCalc(60) * 40 - 5) + ',' + (this.F.y + this.sinCalc(30) * 40 - 10) + ' ' + (this.F.x + this.sinCalc(60) * 40 + 5) + ',' + (this.F.y + this.sinCalc(30) * 40 - 10),
              rotateStart: 'rotate(30, ' + (this.F.x + this.sinCalc(60) * 40) + ', ' + (this.F.y + this.sinCalc(30) * 40) + ')',
              end: (this.E.x + this.sinCalc(60) * 40) + ',' + (this.E.y + this.sinCalc(30) * 40) + ' ' + (this.E.x + this.sinCalc(60) * 40 - 5) + ',' + (this.E.y + this.sinCalc(30) * 40 + 10) + ' ' + (this.E.x + this.sinCalc(60) * 40 + 5) + ',' + (this.E.y + this.sinCalc(30) * 40 + 10),
              rotateEnd: 'rotate(30, ' + (this.E.x + this.sinCalc(60) * 40) + ', ' + (this.E.y + this.sinCalc(30) * 40) + ')'
            }
          },
          id: 6
        }
      }
    }
  }
}
</script>

<style>
</style>
